export class Acc {
    constructor() {
        this.toggleMenus = {};
        this.hasAcc = false;
    }

    init() {
        if (document.querySelectorAll('.js-accordion-btn')[0]) {
            this.hasAcc = true;

            // 複数の場合
            this.toggleMenus = document.querySelectorAll('.js-accordion-btn');
            [].forEach.call(this.toggleMenus, (elem) => {
                //console.log(elem);

                elem.accElem = elem.parentElement.parentElement.querySelector('.js-accordion-container');

                // コンテンツの高さ計算(collapse)
                let listElems = elem.accElem.querySelectorAll('ul.comments-list li');

                if (listElems.length <= 3) {
                    //this.toggleMenus.parentElement.classList.add('hide');
                    [].forEach.call(this.toggleMenus, (elem) => {
                        elem.parentElement.classList.add('hide');
                    });
                }else{
                    elem.closeHeight = 0;
                    for (let i = 0; i < 3; i++) {
                        if (listElems[i] !== undefined) {
                            elem.closeHeight += listElems[i].clientHeight;
                        }
                    }
    
                    //collapse状態にセット
                    elem.accElem.style.height = elem.closeHeight + 'px';
    
                    //ボタン
                    elem.addEventListener('click', (e) => {
                        e.preventDefault();
                        //console.log(elem);
                        this.accClickToggle(elem);
                    });
                }
                
            });
        }
    }

    accClickToggle(elem) {

        // コンテンツの高さ計算(open)
        elem.openHeight = elem.parentElement.parentElement.querySelector('.js-accordion-container ul.comments-list').clientHeight;
        //console.log(elem + ', openHeight=' + elem.openHeight);

        // 複数の場合
        if (elem.classList.contains('open')) {
            elem.classList.remove('open');
            elem.accElem.style.height = elem.closeHeight + 'px';
        } else {
            elem.classList.add('open');
            elem.accElem.style.height = elem.openHeight + 'px';
        }
    }

    accResize() {
        if (this.hasAcc) {
            console.log('window resize -> acc resize');
            [].forEach.call(this.toggleMenus, (elem) => {

                // コンテンツの高さ計算(open)
                elem.openHeight = elem.parentElement.parentElement.querySelector('.js-accordion-container ul.comments-list').clientHeight;

                // コンテンツの高さ計算(collapse)
                let listElems = elem.accElem.querySelectorAll('ul.comments-list li');
                elem.closeHeight = 0;
                for (let i = 0; i < 3; i++) {
                    if (listElems[i] !== undefined) {
                        elem.closeHeight += listElems[i].clientHeight;
                    }
                }

                if (elem.classList.contains('open')) {
                    elem.accElem.style.height = elem.openHeight + 'px';
                }
            });
        }
    }

}